export type JudgeScoreStatus = 'not_started' | 'draft' | 'finalized';

export interface JudgeEventClass {
  id: number;
  name: string;
  sort_order: number;
}

export interface JudgeProgress {
  total: number;
  finalized: number;
  drafts: number;
  remaining: number;
  not_started: number;
  percent: number;
}

export interface JudgeEventSummary {
  id: number;
  title: string;
  slug: string;
  location: string | null;
  city: string | null;
  state: string | null;
  start_at: string | null;
  end_at: string | null;
  status: string;
}

export interface EventJudgeClassRef {
  id: number;
  name: string | null;
}

export interface EventJudgeProgress {
  finalized: number;
  drafts: number;
  assigned_total: number;
}

export interface EventJudge {
  id: number;
  event_id: number;
  user_id: number;
  username: string;
  first_name: string | null;
  last_name: string | null;
  class_ids?: number[];
  classes?: EventJudgeClassRef[];
  progress?: EventJudgeProgress;
}

export interface JudgeRegistration {
  id: number;
  event_id: number;
  vehicle_id: number;
  class_id: number | null;
  status: string;
  class_name: string | null;
  owner_username: string;
  owner_display_name?: string;
  my_score_status: JudgeScoreStatus;
  my_score_id?: number | null;
  photo_url?: string | null;
  vehicle: {
    year: number;
    make: string;
    model: string;
    trim: string;
    nickname: string | null;
    public_slug: string | null;
    engine: string | null;
    transmission: string | null;
  };
}

export interface JudgeEventDashboard {
  event: JudgeEventSummary | null;
  assigned_class_ids: number[];
  classes: JudgeEventClass[];
  registrations: JudgeRegistration[];
  progress: JudgeProgress;
}

export interface JudgeScore {
  id: number;
  event_id: number;
  registration_id: number;
  judge_user_id: number;
  score_exterior: number | null;
  score_interior: number | null;
  score_engine: number | null;
  score_execution: number | null;
  score_creativity: number | null;
  is_finalized: boolean;
  notes: string | null;
}

export interface ClassProgress {
  class_id: number;
  name: string;
  vehicle_count: number;
  with_finalized_scores: number;
  scoring_complete_count: number;
  ready_for_results: boolean;
  remaining: number;
}

export interface EventResult {
  registration_id: number;
  vehicle_id: number;
  class_id?: number | null;
  vehicle_label: string;
  class_name: string | null;
  averages: Record<string, number | null>;
  overall_average: number | null;
  judge_count: number;
  finalized_judge_count?: number;
  draft_judge_count?: number;
  scoring_complete?: boolean;
  is_tied?: boolean;
}

export interface EventResultsPayload {
  results: EventResult[];
  class_progress: ClassProgress[];
  judge_assigned_count: number;
  formula: string;
}

export interface VehicleAward {
  id: number;
  event_id: number;
  vehicle_id: number;
  title: string;
  placement: string | null;
  is_published: boolean;
  published_at: string | null;
  event_title: string | null;
  event_slug: string | null;
}

export interface PublishAwardInput {
  registration_id: number;
  title: string;
  placement?: string;
  class_id?: number;
}

export const SCORE_CATEGORIES = [
  { key: 'exterior', label: 'Exterior' },
  { key: 'interior', label: 'Interior' },
  { key: 'engine', label: 'Engine' },
  { key: 'execution', label: 'Execution' },
  { key: 'creativity', label: 'Creativity' },
] as const;
